<template>
    <div>
        <h4 v-if="!history">{{$t('PROMOTIONS.regularPromotions')}}</h4>
        <p v-if="promotions.length === 0 && !history">{{$t('PROMOTIONS.noPromotions')}}</p>
        <table class="table table-bordered table-hover promotions-table" v-if="promotions.length !== 0">
            <thead>
            <tr>
                <table-head-with-sort :text="$t('COMMON.product')"
                                      :showControls="false"/>
                <table-head-with-sort :text="$t('COMMON.price')"
                                      :sortType="'price'"
                                      @sort="handleSort"/>
                <table-head-with-sort :text="$t('PROMOTIONS.startDate')"
                                      :sortType="'startTime'"
                                      @sort="handleSort"/>
                <table-head-with-sort :text="$t('PROMOTIONS.endDate')"
                                      :sortType="'endTime'"
                                      @sort="handleSort"/>
                <table-head-with-sort :text="$t('COMMON.status')"
                                      :showControls="false"/>
                <table-head-with-sort :text="$t('COMMON.active')"
                                      :sortType="'active'"
                                      @sort="handleSort" v-if="!history"/>
                <table-head-with-sort :text="$t('UI.remove')"
                                       v-if="editMode"/>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(promotion) in sortPromotions"
                :key="`regular-promotion-${promotion.id}`"
                >
                <td>{{getProductById(promotion.productId)}}</td>
                <td>
                    <vue-numeric :decimal-separator="decimalSeparator"
                                 :separator="separator"
                                 :currency="symbol"
                                 currency-symbol-position="suffix"
                                 :read-only="true"
                                 :precision="fractionalDigits"
                                 :value="promotion.price"></vue-numeric>
                </td>
                <td>{{parseDate(promotion.startTime)}}</td>
                <td>{{parseDate(promotion.endTime)}}</td>
                <td v-if="hasFinished(promotion)">
                    {{$t('PROMOTIONS.promotionFinished')}}
                </td>
                <td v-else-if="hasStarted(promotion)">
                    {{daysLeft(promotion)}}
                </td>
                <td v-else>
                    {{daysToStart(promotion)}}
                </td>
                <td v-if="!history" class="p-1">
                    <div v-if="!editMode">{{promotion.active ? $t('COMMON.active') : $t('COMMON.inactive')}}</div>
                    <vue-checkbox-toggle
                        v-else
                        ref="checkbox"
                        v-model="promotion.active"
                        :value="promotion.active"
                        @focus="promotion.focused=true"
                        @clicked="activatePromotion(promotion)"
                    >
                    </vue-checkbox-toggle>
                </td>
                <td v-if="editMode" class="p-1">
                    <cph-button @clicked="removePromotion(promotion.id)"
                                :buttonText="'Remove'"
                                :classList="'btn btn-warning btn-sm'">
                    </cph-button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import PromotionMixin from './PromotionMixin';
import TableHeadWithSort from '../../Shared/UI/Table/TableHeadWithSort';
import VueNumeric from 'vue-numeric';
import VueCheckboxToggle from '../../Shared/Toggler';
import CphButton from '../../Shared/UI/Button/CphButton';

export default {
    name: 'ActiveRegularPromotions',
    props: {
        promotions: {
            type: [Array, Object]
        },
        symbol: '',
        history: {
            type: Boolean,
            default: false
        },
        edit: {
            type: Boolean,
            default: false
        },
        bulk: {
            type: Boolean,
            default: false
        },
        fractionalDigits: 0,
        decimalSeparator: {
            deafult: "."
        },
        separator: {
             default: ","
        }
    },
    mixins: [PromotionMixin],
    components: {
        TableHeadWithSort,
        VueNumeric,
        VueCheckboxToggle,
        CphButton
    },
    data(){
        return {
            editMode: false
        }
    },
    created(){
        this.editMode = this.edit || this.$route.name === 'FastEdit'
    },
    computed: {
            ...mapGetters(['getDefaultProducts', 'getDefaultProductById']),
    },
    methods: {
        ...mapMutations(['updatePromotions']),
        getProductById(id){
            const product = this.getDefaultProductById(id)[0];
            if(product){
                if(product.formats && product.formats[0]){
                    return product.formats[0].displayString;
                }
                if(product.availableLayouts && product.availableLayouts[0]){
                    return product.availableLayouts[0].title;
                }
            }
            return id;
        },
        ...mapMutations(['updatePromotions']),
        activatePromotion(promotion){
            const acState = {...promotion};
            if(this.bulk){
                this.$emit('bulkActivatePromotion', acState)
                return;
            }
            this.$emit("addFunctionToSave", {id: `${new Date().getTime()}-active-regular-update`, run: () => {
                this.$store.dispatch('updatePromotionAsync', acState);
                // console.log("acState 2", acState)
                // this.$store.dispatch('getFees');
            }})
            this.$emit('showInformationUpdateCubes')
            this.$emit('saveFunctions')
        },
        async removePromotion (id) {
            const updatedPromotions = this.promotions.filter((promo) => promo.id !== id);

            this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.removePromotion'),
                callback: (decision = false) => {
                    if(decision === true) {
                        this.updatePromotions(updatedPromotions);
                        if(this.bulk){
                            this.$emit('bulkRemovePromotion', id)
                            return;
                        }
                        this.$emit("addFunctionToSave", {
                            run: () => {
                                this.$store.dispatch('deletePromotionByIdAsync', id);
                            },
                            id: `${new Date().getTime()}-delete-regular-promotion-${id}`
                        })
                        this.$emit("addFunctionToSave", {
                            run: () => {
                                this.$store.dispatch('getPromotionsAsync');
                            },
                            id: `${new Date().getTime()}-get-regular-promotion-${id}`
                        })
                        this.$emit('showInformationUpdateCubes')
                        this.$emit('saveFunctions')
                    }
                }
            })
        },
    }
};
</script>
